<template>
  <div :class="{'station-pt-item':true, 'station-pt-item-current': current, 'station-pt-item-completed': completed, 'station-pt-item-paused': paused, 'station-pt-item-highlight': highlighted, 'station-pt-item-error': errored}">
    <div class="station-pt-item-head-spacer">
      <div class="station-pt-left">
        <div class="station-pt-line"> </div>
      </div>
      <div class="station-pt-right"> </div>
    </div>
    <div class="station-pt-item-header">
      <div class="station-pt-left">
        <div class="station-pt-circle">
          <i :class="[completed ? 'fas' : 'fal', displayIcon]"></i>
        </div>
      </div>
      <div class="station-pt-header-info">
        <div class="station-pt-header-title">{{title}}</div>
      </div>
    </div>
    <div class="station-pt-item-content">
      <div class="station-pt-left">
        <div class="station-pt-line"> </div>
      </div>
      <div class="station-pt-right station-pt-content-area">
        <div v-if="locationName">{{locationName}}</div>
        <div v-if="!pending && startedDate">Started: <span class="stage-task-value">{{startedDate | formatDateCustom('h:mma Do MMM')}} <span v-if="scanInStation">@ {{scanInStation}}</span></span></div>
        <div v-if="!completed && dueDate">Due: <span class="stage-task-value">{{dueDate | formatDateCustom('h:mma Do MMM')}}</span></div>
        <div v-if="completed && completedDate">Completed: <span class="stage-task-value">{{completedDate | formatDateCustom('h:mma Do MMM')}} <span v-if="scanOutStation">@ {{scanOutStation}}</span></span></div>
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
$left-padding-size: 6px;
$pt-icon-size: 30px;
$pt-line-width: 5px;
$pt-line-left: 12px;    // icon-size / 2 - line-width / 2
$pending-color: #a5aab1;
$completed-color: #4EB93C;
$cancelled-color: #ed6666;
$current-color: #FF9639;
$highlight-color: #57b0f0;
$current-paused-color: #FF9639;
$current-paused-opacity: 0.6;
$content-width-fraction: 1.0;


.station-pt-item-head-spacer {
  display: none;
  padding-left: $left-padding-size;
}
.station-pt-item:not(:first-child) .station-pt-item-head-spacer {
  display: flex;
}
.station-pt-item-head-spacer .station-pt-right {
  height: 12px;
}
.station-pt-item-current {
  background-color: #e2e2e0;
  border-radius: 6px;
}
.theme-dark .station-pt-item-current {
  background-color: #6a6a6a;
}

.station-pt-item-header {
  display: flex;
  padding-left: $left-padding-size;
}
.station-pt-item-content {
  display: flex;
  padding-left: $left-padding-size;
}
.station-pt-item:last-child .station-pt-item-content .station-pt-left .station-pt-line {
  display: none;
}
.station-pt-left {
  flex-basis: 40px;
}
.station-pt-right {
  flex-grow: 1.0;
}
.station-pt-content-area {
  flex-grow: $content-width-fraction;
  margin-top: -10px;
  padding-top: 0px;
  padding-bottom: 0.9rem;
  font-size: 0.70rem;
  color: inherit;
}
.station-pt-content-area p {
  margin-bottom: 0.33rem;
}
.station-pt-content-area h4 {
  color: #676a6c;
}
.station-pt-content-area h5 {
  color: #676a6c;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.70rem;
  margin: 0 0 4px 0;
}
.station-pt-line {
  width: $pt-line-width;
  height: 100%;
  margin-left: $pt-line-left;
  background-color: $pending-color;
}
.station-pt-item-completed .station-pt-line {
  background-color: $completed-color;
}
.station-pt-item-cancelled .station-pt-line {
  background-color: $cancelled-color;
}
.station-pt-item-error .station-pt-line {
  background-color: $cancelled-color;
}
.station-pt-item-current .station-pt-line {
  background-color: $current-color;
}
.station-pt-item-highlight .station-pt-line {
  background-color: $highlight-color !important;
}
.station-pt-item-current.station-pt-item-paused .station-pt-line {
  background-color: $current-paused-color;
  opacity: $current-paused-opacity;
}
.station-pt-header-info {
  flex-grow: $content-width-fraction;
  line-height: 1.0rem;
}

.station-pt-header-title {
  font-size: 0.90rem;
  font-weight: 600;
  color: inherit;
}
.station-pt-item-completed .station-pt-header-title {
  color: $completed-color;
}
.station-pt-item-cancelled .station-pt-header-title {
  color: $cancelled-color;
}
.station-pt-item-error .station-pt-header-title {
  color: $cancelled-color;
}
.station-pt-item-current .station-pt-header-title {
  color: $current-color;
}
.station-pt-item-highlight .station-pt-header-title {
  color: $highlight-color;
}
.station-pt-item-current.station-pt-item-paused .station-pt-header-title {
  color: $current-paused-color;
  opacity: $current-paused-opacity;
}
.station-pt-header-info small {
  font-size: 0.70rem;
  color: #a0a0a0;
}
.station-pt-circle {
  width: $pt-icon-size;
  height: $pt-icon-size;
  border-radius: 50%;
  background-color: $pending-color;
  color: #ffffff;
  line-height: $pt-icon-size;
  vertical-align: middle;
  text-align: center
}
.station-pt-circle i {
  line-height: $pt-icon-size;
  font-size: 1.0rem;
}
.station-pt-item-completed .station-pt-circle {
  background-color: $completed-color;
}
.station-pt-item-cancelled .station-pt-circle {
  background-color: $cancelled-color;
}
.station-pt-item-error .station-pt-circle {
  background-color: $cancelled-color;
}
.station-pt-item-current .station-pt-circle {
  background-color: $current-color;
}
.station-pt-item-highlight .station-pt-circle {
  background-color: $highlight-color;
}
.station-pt-item-current.station-pt-item-paused .station-pt-circle {
  background-color: $current-paused-color;
  opacity: $current-paused-opacity;
}

.stage-task-value {
  color: #ffffff;
  font-weight: 500;
}

</style>

<script>
export default {
  name: 'StationProgressTrackerItem',
  props: {
    title: String,
    note: String,
    pending: Boolean,
    completed: Boolean,
    current: Boolean,
    highlighted: Boolean,
    errored: Boolean,
    paused: Boolean,
    icon: {
      type: String,
      default: 'fa-tools'
    },
    startedDate: String,
    dueDate: String,
    completedDate: String,
    locationName: String,
    scanInStation: String,
    scanOutStation: String
  },
  computed: {
    displayIcon() {
      if(this.errored)
        return 'fa-exclamation'
      if(this.completed)
        return 'fa-check'
      if(this.paused && this.current)
        return 'fa-pause'
      return this.icon
    }    
  }
}
</script>